import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IUnitMeasurement from '../interfaces/IUnitMeasurement';
import Layout from '~/components/Layout';

export default function Create() {     
  const {register, handleSubmit, control, setValue:setFormValue} = useForm<IUnitMeasurement>();
  const fields = [
      { name: 'name', type: 'string'},
  ];
  
    return(
      <Layout marginLayout={true}>
        <CrudCreate model={'unit-measurement'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        messageSuccess={'Unit Measurement successfully created!'}  
        title={'Add unit measurement'}  
        subheader={'Add unit measurement'}
        setFormValue={setFormValue} />
      </Layout>
    )
}
